import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createAwardhistory } from '../../../../services/AwardhistoryService';
import { connect, useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Row, Col, Button, Card } from 'react-bootstrap';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import Swal from 'sweetalert2';
import { getAwardtypesByCategory } from '../../../../services/AwardtypeService';
import { getAwardceremony } from '../../../../services/AwardceremonyService';
import { getUserJoiningDate } from '../../../../services/UsersServices';
import { getUsersSearch } from '../../../../services/BoxService';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';

const validationSchema = Yup.object().shape({
  employeeName: Yup.object().required('Employee Name is required'),
  employeeNumber: Yup.string().required('Employee Number is required'),
  dateOfJoining: Yup.date().required('Date of Hire is required'),
  nominatorsName: Yup.string().required("Nominator's Name is required"),
  awardType: Yup.string().required('Award Type is required'),
  awardDate: Yup.date().required('Date of Hire is required'),
  spotBonus: Yup.string().default('NA').required('Spot Award Type is required'),
  isApproved: Yup.boolean().default(true).required('Status required'),
  awardAmount: Yup.number()
    .required('Award Amount is required')
    .min(0, 'Award Amount must be 0 or greater'),
});

const AddAwardhistoryForm = ({ employeeList }) => {
  const initialValues = {
    employeeName: '',
    employeeEmail: '',
    employeeNumber: '',
    dateOfJoining: '',
    nominatorsName: '',
    awardDate: moment().toDate(),
    awardType: '',
    spotBonus: 'NA',
    isApproved: true,
    awardAmount: '',
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [awardTypeList, setAwardTypeList] = useState([]);
  const [awardTypeSpotList, setAwardTypeSpotList] = useState([]);
  const [awardCeremonyList, setAwardCeremonyList] = useState([]);
  const [selectedAward, setSelectedAward] = useState(null);

  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  useEffect(() => {
    const getAward = async () => {
      try {
        const data = await getAwardtypesByCategory('normal');
        setAwardTypeList(data);
      } catch (error) {
        console.error('Error fetching awardtype by category normal:', error);
      }
    };
    getAward();

    const getSpotAward = async () => {
      try {
        const data = await getAwardtypesByCategory('spot');
        setAwardTypeSpotList(data);
      } catch (error) {
        console.error('Error fetching awardtype by category spot:', error);
      }
    };
    getSpotAward();

    const getCeremony = async () => {
      try {
        const data = await getAwardceremony();
        setAwardCeremonyList(data);
      } catch (error) {
        console.error('Error fetching awardceremony:', error);
      }
    };
    getCeremony();
  }, []);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const handleSubmit = async (values) => {
    // Send the form data to the server
    try {
      await createAwardhistory({ ...values, employeeName: values.employeeName.label });
      // Show success toast notification
      toast.success('Award History added Successfully!', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate('/settings/awardhistory');
      }, 3000);
      console.log('Award history added successfully');

      // Optionally, redirect or update state after successful add
    } catch (error) {
      console.error('Error adding awardhistory:', error);
      toast.error('Failed to adding Award history!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  };

  const handleEmployeeChange = async (selectedOption, setFieldValue) => {
    setFieldValue(`employeeName`, selectedOption);
    const dateOfJoiningRes = await getUserJoiningDate(selectedOption.email);
    setFieldValue(`employeeNumber`, selectedOption.employeeNumber || 'NA');
    setFieldValue(`employeeEmail`, selectedOption.email);

    if (typeof dateOfJoiningRes.isError != 'undefined' && dateOfJoiningRes.isError == true) {
      Swal.fire({
        icon: 'error',
        title: 'Employee Hire Date Error',
        text: 'Employee hire date not configured with portal, Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });

      setFieldValue(`employeeEmail`, '');
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`dateOfJoining`, moment().toDate());
      return false;
    } else {
      setFieldValue(`dateOfJoining`, moment(dateOfJoiningRes.dateOfJoining).toDate());
    }
  };

  return (
    <>
      <Card>
        <div className="card-body">
          <Row>
            <Col md={12}>
              <h4>Add Award History</h4>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ values, setFieldValue, isSubmitting }) => (
                  <FormikForm>
                    <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="employeeName">Employee Name</label>
                          <AsyncSelect
                            name="employeeName"
                            loadOptions={loadOptions}
                            defaultOptions={employeeList}
                            placeholder="Select Employee Name"
                            isSearchable
                            onChange={(selectedOption) =>
                              handleEmployeeChange(selectedOption, setFieldValue)
                            }
                          />
                          <ErrorMessage
                            name="employeeName"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="employeeNumber">Employee Number</label>
                          <Field
                            type="text"
                            name="employeeNumber"
                            className="form-control"
                            placeholder="Employee Number"
                            readOnly
                            value={values.employeeNumber}
                          />
                          <ErrorMessage
                            name="employeeNumber"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="dateOfJoining">Date of Hire</label>
                          <DatePicker
                            selected={values.dateOfJoining}
                            onChange={(date) => {
                              setFieldValue('dateOfJoining', date);
                            }}
                            className="form-control"
                            dateFormat="MM/dd/yyyy"
                            placeholderText="MM/DD/YYYY"
                            readOnly
                          />
                          <ErrorMessage
                            name="dateOfJoining"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="nominatorsName">Nominator's Name</label>
                          <AsyncSelect
                            name="nominatorsName"
                            loadOptions={loadOptions}
                            defaultOptions={employeeList}
                            placeholder="Select Nominator's Name"
                            isSearchable
                            onChange={(selectedOption) =>
                              setFieldValue('nominatorsName', selectedOption.label)
                            }
                          />
                          <ErrorMessage
                            name="nominatorsName"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="awardType">Award Type</label>
                          <Select
                            name="awardType"
                            options={awardTypeList}
                            placeholder="Award Type"
                            isSearchable
                            onChange={(selectedOption) => {
                              setSelectedAward(selectedOption);
                              setFieldValue('awardType', selectedOption.label);
                              setFieldValue('awardAmount', selectedOption.amount);
                            }}
                          />
                          <ErrorMessage name="awardType" component="div" className="text-danger" />
                        </div>
                      </Col>
                      {selectedAward && selectedAward.showSpotBonus == true && (
                        <Col>
                          <div className="form-group">
                            <label htmlFor="spotBonus">Spot Award Type</label>
                            <Select
                              name="spotBonus"
                              options={awardTypeSpotList}
                              placeholder="Spot Award Type"
                              isSearchable
                              onChange={(selectedOption) => {
                                setFieldValue('spotBonus', selectedOption.label);
                                setFieldValue('awardAmount', selectedOption.amount);
                              }}
                            />
                            <ErrorMessage
                              name="spotBonus"
                              component="div"
                              className="text-danger"
                            />
                          </div>
                        </Col>
                      )}
                      <Col>
                        <div className="form-group">
                          <label htmlFor="awardCeremony">Status</label>
                          <Select
                            name="isApproved"
                            options={[
                              {
                                label: 'Approved',
                                value: true,
                              },
                              {
                                label: 'Rejected',
                                value: false,
                              },
                            ]}
                            placeholder="Status"
                            isSearchable
                            onChange={(selectedOption) =>
                              setFieldValue('isApproved', selectedOption.value)
                            }
                            defaultValue={values.isApproved}
                          />
                          <ErrorMessage name="isApproved" component="div" className="text-danger" />
                        </div>
                      </Col>

                      <Col>
                        <div className="form-group">
                          <label htmlFor="awardAmount">Award Amount ($)</label>
                          <div className="input-group">
                            <span className="input-group-text">$</span>
                            <Field
                              type="number"
                              name="awardAmount"
                              className="form-control"
                              placeholder="Award Amount"
                              min="0"
                              step="0.01"
                            />
                          </div>
                          <ErrorMessage
                            name="awardAmount"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <div className="form-group">
                          <label htmlFor="awardDate">Date of Award</label>
                          <DatePicker
                            selected={values.awardDate}
                            onChange={(date) => {
                              setFieldValue('awardDate', date);
                            }}
                            className="form-control"
                            dateFormat="MM/dd/yyyy"
                            placeholderText="MM/DD/YYYY"
                          />
                          <ErrorMessage name="awardDate" component="div" className="text-danger" />
                        </div>
                      </Col>
                    </Row>

                    <div className="d-flex justify-content-end">
                      <Button variant="primary" type="submit">
                        Submit
                      </Button>
                    </div>
                  </FormikForm>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(AddAwardhistoryForm);
